import {Component} from '@angular/core';

@Component({
  selector: 'app-management',
  templateUrl: 'management.component.html'
})
export class ManagementComponent  {
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/management/management.component.ts